import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";  
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";  
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";  
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";    
import useMaxCopaySchedule from "./hooks/useMaxCopaySchedule";  
  
const MaxCopaySchedule = ({onSelect, hideModal, params, selectMode, lookupType}) => {  
  const maxCopayScheduleData = useMaxCopaySchedule(onSelect, hideModal, params, selectMode, lookupType);  
  return (  
    <div class="container container-fluid">  
    <ButtonsSection ctaButtons={maxCopayScheduleData.leftButtons} align="left" />
      <div className="header-section">  
        <h1>  
          {maxCopayScheduleData.screen_title} -{" "}  
          <span className="heading-cod">{maxCopayScheduleData.screenNumber}</span>  
        </h1>  
      </div>  
      <SearchBox  
        formFields={maxCopayScheduleData.formFields}  
        dropdownValues={maxCopayScheduleData.dropdownValues}  
        paramsData={maxCopayScheduleData.paramsData}  
        updataParamData={maxCopayScheduleData.updateParamData}  
      />  
      <ButtonsSection ctaButtons={maxCopayScheduleData.ctaButtons} />  
      <DisplayTable  
        selectMode={maxCopayScheduleData.selectMode}
        data={maxCopayScheduleData.data}  
        parmKey={maxCopayScheduleData.parmKey}  
        menuOptions={maxCopayScheduleData.menuOptions}  
        tableHeaders={maxCopayScheduleData.columnDef}  
        setRowData={maxCopayScheduleData.setRowData}  
        selectedPriceSchedules={maxCopayScheduleData.selectedRows}  
        setSelectedPriceSchedules={maxCopayScheduleData.setSelectedRows}  
      />  
      <div className="paginator-container">  
        <NextGenPaginator  
          first={maxCopayScheduleData.first}  
          rows={maxCopayScheduleData.rows}  
          totalRecords={maxCopayScheduleData.totalRecords}  
          currentPage={maxCopayScheduleData.currentPage}  
          rowsPerPageOptions={[10, 25, 50]}  
          onPageChange={maxCopayScheduleData.onPageChange}  
        />  
      </div>  
      {maxCopayScheduleData.isConfirmationModalOpen && (  
        <ConfirmationModal  
          isOpen={maxCopayScheduleData.isConfirmationModalOpen}  
          onRequestClose={maxCopayScheduleData.closeConfirmationModal}  
          onBack={maxCopayScheduleData.closeConfirmationModal}  
          onSave={maxCopayScheduleData.deletePriceSchedule}  
          confirmLabel="Confirm(Y/N)"  
          options={[  
            { label: "N-No", value: "no" },  
            { label: "Y-Yes", value: "yes" },  
          ]}  
          setSelectedOption={maxCopayScheduleData.setSelectedOption}  
        />  
      )}  
    </div>  
  );  
};  
  
export default MaxCopaySchedule;  